import { CreateRailTrackRequest, RailTrackResponse, UpdateRailTrackRequest } from '@yard/app/api';
import { IRailTrackFormData } from '../models/yard-setup.model';

export const mapRailTrackFormDataToCreateCommand = (
  data: IRailTrackFormData,
  position?: { x: number; y: number },
): CreateRailTrackRequest => {
  const RailTrack = {
    id: new Date().getTime().toString(), // Temporary ID generation until backend is implemented
    name: data.name,
    length: data.length ?? 0,
    layoutPosition: {
      x: Math.round(position?.x ?? 0),
      y: Math.round(position?.y ?? 0),
      rotation: 0,
    },
  }

  return RailTrack
}

export const mapRailTrackFormDataToUpdateCommand = (
  data: IRailTrackFormData,
  RailTrack: RailTrackResponse,
): UpdateRailTrackRequest => {
  const updatedRailTrack = {
    ...RailTrack,
    name: data.name,
    length: data.length ?? 0,
  }

  return updatedRailTrack
}
